import { CapoPlugin } from "/opt/build/repo/node_modules/.pnpm/@unhead+vue@1.11.14_vue@3.5.13_typescript@5.7.2_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];